import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { UtilFormTypes } from "models/formTypes";
import { WintFormConnect } from "models/propTypes/wintFormPropsTypes";
import { CostForwarding } from "models/utilTypes/costForwardingTypes";
import { getCostForwardingStatus, isCostForwardingLocked } from "./costForwardingMarkingModel";
//#endregion
//#region components
import { StaticInfoMessage } from "components/common";
import CostForwardingCustomerFields from "./costForwardingCustomerFields";
import CostForwardingInvoiceLink from "./costForwardingInvoiceLink";
import { getCostForwardingLockedText } from "./costForwardingStatusText";
//#endregion

interface CostForwardingFieldsProps {
  connect: WintFormConnect<UtilFormTypes.CostForwardingMarking>;
  values: UtilFormTypes.CostForwardingMarking;
  marking?: CostForwarding;
}

/**
 * Customer and description, with a message on why a locked marking cannot be changed; each form supplies its
 * own section. A locked cost is released from its document page, not here.
 */
const CostForwardingFields: React.FC<CostForwardingFieldsProps> = ({ connect, values, marking }) => {
  const isLocked = isCostForwardingLocked(values.costForwardingState);
  const lockedLabel = isLocked && marking ? getCostForwardingStatus(marking).label : undefined;

  return (
    <>
      {lockedLabel && lockedLabel.key !== "ReadyForForwarding" && (
        <StaticInfoMessage displayType={StyleEnums.DisplayType.Info} fullWidth>
          {getCostForwardingLockedText(lockedLabel)}
          {marking && <CostForwardingInvoiceLink marking={marking} />}
        </StaticInfoMessage>
      )}
      <CostForwardingCustomerFields connect={connect} presentation="form" disabled={isLocked} />
    </>
  );
};

export default CostForwardingFields;
